import type { SVGProps } from 'react';

export default function WaveIcon({ size = 22, ...props }: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M2 16h3c1.5 0 1.5-4 3-4s1.5 8 3 8c2 0 2-14 5-14s3 20 6 20c2.5 0 2.5-16 5-16 2 0 2 10 4 10h1" />
    </svg>
  );
}
